import React, { createContext, useContext, useState } from 'react';

const ValidationErrorModalContext = createContext<[boolean, (boolean) => void]>(
  [false, () => {}]
);

export const ValidationErrorModalProvider = ({ children }) => {
  const modalState = useState(false);

  return (
    <ValidationErrorModalContext.Provider value={modalState}>
      {children}
    </ValidationErrorModalContext.Provider>
  );
};

export const useValidationErrorModal = () => {
  return useContext(ValidationErrorModalContext);
};
